<template>
  <el-dialog
    width="60%"
    title="项目术语表"
    :visible="visible"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div class="d-f justify-b m-b-10">
      <section class="d-f">
        <el-input
          placeholder="请输入原文"
          v-model="searchText"
          clearable
        ></el-input>
        <el-button type="primary" class="m-l-15" @click="toSearch">
          搜索
        </el-button>
      </section>
      <el-button
        type="primary"
        icon="el-icon-circle-plus-outline"
        plain
        @click="openAdd"
      >
        新增术语
      </el-button>
    </div>
    <div class="c-red m-tb-10">
      如需修改术语表中的术语，请直接点击新增术语，在原文框输入术语原文，译文框直接填入新的术语译文，保存即可
    </div>
    <el-table :data="termList" border style="width: 100%">
      <el-table-column prop="srcText" label="原文"></el-table-column>
      <el-table-column prop="tranText" label="译文"></el-table-column>
      <el-table-column prop="address" label="操作" width="50">
        <template slot-scope="scope">
          <el-button type="text" @click="deleteTerm(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block t-r">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import { orderTermPage, delOrderTerm } from '@/api/dot/qc';
export default {
  name: 'TermDialog',
  props: [
    'visible',
    'staParams', // 上报公共参数
    'orderId', // 当前订单id
    'qcTaskId',
  ],
  data() {
    return {
      searchText: null,
      termList: [],
      page: {
        size: 10,
        current: 1,
        total: 0,
        pages: 0,
      },
    };
  },
  watch: {
    visible(val) {
      // 弹窗每次出现都要拉取术语列表
      if (val) {
        this.getTermList();
      }
    },
  },
  methods: {
    toSearch() {
      this.page.current = 1;
      this.getTermList();
    },

    getTermList() {
      orderTermPage({
        orderId: this.orderId,
        srcText: this.searchText,
        current: this.page.current,
        size: this.page.size,
      }).then((res) => {
        this.termList = res.data?.data?.records;
        this.page.total = res.data?.data?.total;
      });
    },

    // 关闭弹窗回调
    closeDialog() {
      this.$emit('update:visible', false);
    },

    handleSizeChange(val) {
      this.page.size = val;
      this.getTermList();
    },

    handleCurrentChange(val) {
      this.page.current = val;
      this.getTermList();
    },

    deleteTerm(row) {
      this.$confirm(
        '删除术语后无法恢复，已经加持该术语的句子请按原文筛选进行修改哦～',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          delOrderTerm({
            orderId: this.orderId,
            id: row.id,
            qcTaskId: this.qcTaskId,
          }).then((res) => {
            this.getTermList();
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
          });
        })
        .catch(() => {});
    },

    openAdd() {
      this.closeDialog();
      this.$emit('open-term-dialog');
    },
  },
};
</script>
